import { render } from "./NotFoundComponent.vue?vue&type=template&id=21349f4a"
const script = {}
script.render = render

export default script